<template>
  <div
    :class="boxWidgetClass"
    :style="{
      '--bw-bc': backgroundColor,
    }"
  >
    <BoxHeader
      :name="title ? title : layoutItem.i"
      :selected="layoutItem.selected"
      :minimized="layoutItem.minimized"
      :isPinnable="isPinnable"
      @click="selectBox(layoutItem.i)"
      @minimize="minimizeBox(layoutItem.i)"
      @maximize="maximizeBox(layoutItem.i)"
      @pin="pinBox(layoutItem.i)"
    ></BoxHeader>
    <div class="box-body" @click="onBodyClick">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import BoxHeader from "../../plugins/box-header/box-header";
import VueGridLayout from "vue-grid-layout";

export default {
  components: {
    GridItem: VueGridLayout.GridItem,
    BoxHeader,
  },
  props: {
    title: {
      type: String,
    },
    layoutItem: {
      type: Object,
    },
    selected: false,
    isPinnable: {
      type: Boolean,
    },
    backgroundColor: {
      type: String,
      default: "white",
    },
  },
  computed: {
    boxWidgetClass: function () {
      return {
        "box-widget": true,
        selected: this.layoutItem.selected,
        minimized: this.layoutItem.minimized,
      };
    },
  },
  methods: {
    selectBox: function () {
      this.$emit("selected", this.layoutItem.i);
    },
    minimizeBox: function () {
      this.$emit("minimized", this.layoutItem.i);
    },
    maximizeBox: function () {
      this.$emit("maximized", this.layoutItem.i);
    },
    pinBox: function () {
      this.$emit("pin", {
        element: this.$el,
        title: this.layoutItem.i,
      });
    },
    toggleExpandCollapse(flag) {
      // console.log({ flag: flag });
      // console.log({ "this.layoutItem": this.layoutItem });

      this.layoutItem.h = flag
        ? this.layoutItem.expandedHeight
        : this.layoutItem.collapsedHeight;
    },
    log: function (e) {
      console.log(e);
    },
    onBodyClick: function () {
      this.$emit("selected", this.layoutItem.i);
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.box-widget {
  height: 100%;
  background-color: var(--bw-bc);

  // Flex implementation
  display: flex;
  flex-direction: column;

  transition: 150ms ease-out;

  .box-body {
    // display: flex;

    background: var(--bw-bc);

    // height: calc(100% - 31px);
    height: 100%;

    overflow-y: auto;

    // border-right: 1px solid transparent;
    // border-bottom: 1px solid transparent;
    // border-left: 1px solid transparent;
  }

  &.selected {
    .box-body {
      // border-right: 1px solid var(--brd-5);
      // border-bottom: 1px solid var(--brd-5);
      // border-left: 1px solid var(--brd-5);
    }
  }

  &.minimized {
    height: 0px;

    .box-body {
      display: none;
    }
  }

  --bw-bdc: var(--brd-5);
  // --bw-bc: red;
  --bw-bd: 1px solid var(--bw-bdc);

  border-top: 1px solid transparent;
  border-right: 1px solid transparent;
  border-bottom: 1px solid transparent;
  border-left: 1px solid transparent;

  &:hover:not(.selected) {
    border-top: var(--bw-bd);
    border-right: var(--bw-bd);
    border-bottom: var(--bw-bd);
    border-left: var(--bw-bd);

    .box-header {
      border-top: var(--bw-bd);
      border-left: var(--bw-bd);
      border-right: var(--bw-bd);
    }

    .box-body {
      // border-right: var(--bw-bd);
    }
  }

  --fc2-bc: transparent;

  /* &:hover {
    // For Boxwidgets containing FC2 Elements -
    // FC2 BC is modified because of the BoxWidget Hover Highlight Feature

    --fc2-bc: var(--bc-cblue);
  } */

  &.selected {
    border-right: var(--bw-bd);
    border-bottom: var(--bw-bd);
    border-left: var(--bw-bd);
  }
}

span.vue-resizable-handle {
  opacity: 0;

  &:hover {
    opacity: 1;
  }
}
</style>
